export function fadeIn(duration = 0.5, delay = 0) {
  return {
    from: {
      opacity: 0,
      transition: {
        type: "ease",
        duration: duration,
        delay: delay,
      },
    },
    to: {
      opacity: 100,
      transition: {
        type: "ease",
        duration: duration,
        delay: delay,
      },
    },
  };
}
